import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthFacadeService } from '@ib-core/services/auth-facade.service';
import { MatSnackBarService } from '@ib-core/services/snackbar.service';

import { WithdrawFacadeService } from '../services/withdraw-facade.service';
import { WithdrawStateService } from '../services/withdraw-state.service';

@Component({
  selector: 'ib-withdraw',
  templateUrl: './withdraw.component.html',
  styleUrls: ['./withdraw.component.scss'],
  providers: [WithdrawStateService, WithdrawFacadeService],
})
export class WithdrawComponent implements OnInit {
  public authUser$ = this.authFacadeS.selectAuthUser();
  form: FormGroup;
  loading = false;
  requestSent = false;
  constructor(
    private authFacadeS: AuthFacadeService,
    private fb: FormBuilder,
    private withdrawFacadeS: WithdrawFacadeService,
    private snackbar: MatSnackBarService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      amount: ['', [Validators.required]],
    });
  }

  submit(): void {
    this.loading = true;
    this.form.disable();
    this.withdrawFacadeS
      .increaseBalance(this.form.get('amount').value)
      .subscribe({
        next: () => {
          this.form.enable();
          this.requestSent = true;
          this.loading = false;
        },
        error: () => {
          this.form.enable();
          this.loading = false;
        },
      });
  }
}
